import { cardHeightUI, cardWidthUI } from '@/const/magicNumber';

const Card = ({ cardId, width, height, cardImageArray }) => {
	const CH = height === 0 ? cardHeightUI : height;
	const CW = width === 0 ? cardWidthUI : width;
	let offset = 0;

	if (cardId >= 100) {
		offset = 100;
	}

	return (
		<img
			src={cardImageArray[cardId - offset]}
			alt={'card' + cardId}
			className="card-img"
			width={CW}
			height={CH}
		/>
	);
};

export default Card;
